module.exports = __webpack_public_path__ + "img/146.68580ab6.jpg";